/* 布局 */
//前台
import Layout from "@views/layout";

const userfeedbackRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "userfeedback",
            name: "USERFEEDBACK",
            meta: {
                title: "用户反馈",
                sort: 1,
            },
            component: () => import("@views/business/userfeedback/index.vue"),
            redirect: {
                name: "USERFEEDBACK_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "USERFEEDBACK_LIST",
                    meta: {
                        title: "用户反馈",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/userfeedback/list.vue"),
                },
                                                {
                    path: "edit",
                    name: "USERFEEDBACK_EDIT",
                    meta: {
                        title: "编辑用户反馈",
                        parentPath: '/business/userfeedback/list',
                        operate: true,
                    },
                    component: () => import("@views/business/userfeedback/form.vue"),
                },
                                        ],
    },


        ],
};

export default userfeedbackRouter;
